import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import { Container, Modal, Button } from 'react-bootstrap';
import Header from './Header';
import Logout from './Logout';

import Welcome from './welcome/Welcome';
import LedmodulesCloudList from './ledmodules/LedmodulesCloudList';
import Ledmodule from './ledmodules/Ledmodule';
import ErrorsContainer from '../shared/ErrorsContainer';

// import NavigationPrompt from '../shared/NavigationPrompt';
import Handler from '../shared/Handler';

export const AppTitle = "T4T Field NT Internal";

class App extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isShowingLogoutPopup: false,
        };

        this.handleOpenLogoutPopup = this.handleOpenLogoutPopup.bind(this);
    }

    handleOpenLogoutPopup() {
        this.setState({ isShowingLogoutPopup: true })
    }

    handleCloseLogoutPopup(result) {

        if (!result) {
            this.setState({ isShowingLogoutPopup: false });
        } else {
            this.setState({ isShowingLogoutPopup: false }, this.props.history.push('/logout'));
        }
    }

    render() {

        // const url = window.location.hash.substr(0, window.location.hash.lastIndexOf("/")).replace('#', '');
        // const whiteListedPathnames = [`${url}/info`, `${url}/summary`];

        return (
            <Router>
                <Handler>
                    {/* <NavigationPrompt
                    when={window.location.hash.endsWith("info") || window.location.hash.endsWith("summary")}
                    cancelLabel={'Stay'}
                    confirmLabel={'Leave'}
                    whiteListedPathnames={whiteListedPathnames}
                    title={'Leave This Page'} >
                    <span>
                        Unsaved Changes may not be saved
                    </span>
                </NavigationPrompt> */}
                    <div>
                        <Header handleOpenLogoutPopup={this.handleOpenLogoutPopup} />
                    </div>
                    <div className="content">
                        <Container fluid="true" className="internal-content" >
                            <Switch>
                                <Route exact path="/" component={Welcome} />
                                <Route path="/welcome" component={Welcome} />
                                <Route path="/logout" component={Logout} />

                                <Route path="/ledmodules/:id" component={Ledmodule} />

                                <Route path="/ledmodules" component={LedmodulesCloudList} />
                                <Route path="/ledmodulesOnCloud" component={LedmodulesCloudList} />
                                <Route path="/createLedmodules" component={Ledmodule} />
                            </Switch>
                        </Container>

                        <ErrorsContainer />

                        <Modal show={this.state.isShowingLogoutPopup} onHide={() => this.handleCloseLogoutPopup(false)} animation={false}>
                            <Modal.Header closeButton>
                                <Modal.Title style={{ color: "#E95B0D" }}>Confirmation</Modal.Title>
                            </Modal.Header>

                            <Modal.Body>
                                <p>
                                    Please be aware that the access key to access your private workspace will be deleted from your browser if you proceed logging out
                                </p>
                            </Modal.Body>

                            <Modal.Footer>
                                <Button variant="primary" style={{ marginRight: "0" }} onClick={() => this.handleCloseLogoutPopup(true)}>Continue anyways</Button>
                                <Button variant="secondary" onClick={() => this.handleCloseLogoutPopup(false)}>Cancel</Button>
                            </Modal.Footer>
                        </Modal>
                    </div>
                </Handler>
            </Router>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        errors: state.errorsHandler.errors,
        notFound: state.errorsHandler.notFound
    };
};

const mapDispatchToProps = {
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(App));